import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';
import { useHistory } from 'react-router-dom';

import FullScreenLoader from '../FullScreenLoader';
import { MeQuery } from '../../../graphql/queries/account';
import ErrorView from '../ErrorView';
import {
  getDefaultProRoleFromAccount,
  isProAccount,
} from '../../../util/account';
import { getRoleBasename } from '../../../util/role-definitions';

const ManageSubscriptions = () => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  const history = useHistory();

  useEffect(() => {
    if (user) {
      const role = getDefaultProRoleFromAccount(user);
      const basename = getRoleBasename(role);

      if (isProAccount(user)) {
        history.replace(`/app/${basename}/account/settings/photo-manager`);
      } else {
        history.replace(`/app/${basename}/account/settings/subscriptions`);
      }
    }
  }, [user?.id]);

  if (!authenticated) {
    // Safeguard, should never happen as the route has requireAuth.
    return (
      <ErrorView
        location={{
          state: {
            error: 'You must be authenticated in order to view this page.',
          },
        }}
      />
    );
  }

  return <FullScreenLoader />;
};

export default ManageSubscriptions;
